import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * Product Routes and Pages
 */
const ListOurproductPage = React.lazy(() => import("./ListOurproductPage"));
const AddOurproductPage = React.lazy(() => import("./AddOurproductPage.js"));
const EditOurproductPage = React.lazy(() => import("./EditOurproductPage.js"));

const OurproductRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListOurproductPage />} />
      <Route exact path="/add" element={<AddOurproductPage />} />
      <Route exact path="/edit/:id" element={<EditOurproductPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default OurproductRoutes;
